import XApi from "../../utils/Api";
import XEndpoints from "../../core/config/Endpoints";

export class SettingService {
    // Preferences
    async getPreferences() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(XEndpoints.preferences, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updatePreferences({
                                tcs,
                                tds,
                                transportationCharge,
                                labourCharge,
                                quantity,
                                invoiceNumber,
                                purchaseNumber,
                                creditNoteNumber,
                                debitNoteNumber,
                                receiptVoucherNumber,
                                paymentVoucherNumber,
                                dueDays
                            }: {
        tcs: boolean;
        tds: boolean;
        transportationCharge: boolean;
        labourCharge: boolean;
        quantity: boolean;
        invoiceNumber: string;
        purchaseNumber: string;
        creditNoteNumber: string;
        debitNoteNumber: string;
        receiptVoucherNumber: string;
        paymentVoucherNumber: string;
        dueDays: number;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(XEndpoints.preferences, {
                tcs,
                tds,
                transportationCharge,
                labourCharge,
                quantity,
                invoiceNumber,
                purchaseNumber,
                creditNoteNumber,
                debitNoteNumber,
                receiptVoucherNumber,
                paymentVoucherNumber,
                dueDays
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    // Rate Type
    async addRateType(type: string) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.rateType, {
                type,
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateRateType({id, type, status, deleted}: {
        id: number;
        type?: string;
        status?: string;
        deleted?: boolean;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.rateType}/${id}`, {
                ...(type && {type}),
                ...(status && {status}),
                ...(deleted && {deleted}),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async allRateTypes() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.rateType}/all`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    // Tax Type
    async addTaxType({
                         name, percentage
                     }: {
        name: string;
        percentage: number;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.taxType, {
                name,
                percentage,
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateTaxType({id, name, percentage, status, deleted}: {
        id: number;
        name?: string;
        percentage?: number;
        status?: string;
        deleted?: boolean;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.taxType}/${id}`, {
                ...(name && {name}),
                ...(percentage && {percentage}),
                ...(status && {status}),
                ...(deleted && {deleted}),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async allTaxTypes() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.taxType}/all`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    // Expense Category
    async addExpenseCategory({
                                 name, description
                             }: {
        name: string;
        description?: string;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.expenseCategory, {
                name,
                ...(description && {description}),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateExpenseCategory({id, name, description, status, deleted}: {
        id: number;
        name?: string;
        description?: string;
        status?: string;
        deleted?: boolean;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.expenseCategory}/${id}`, {
                ...(name && {name}),
                ...(description && {description}),
                ...(status && {status}),
                ...(deleted && {deleted}),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async allExpenseCategories() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.expenseCategory}/all`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    // Color Type
    async addColor(name: string) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.color, {
                name,
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateColor({id, name, status, deleted}: {
        id: number;
        name?: string;
        status?: string;
        deleted?: boolean;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.color}/${id}`, {
                ...(name && {name}),
                ...(status && {status}),
                ...(deleted && {deleted}),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async allColors() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.color}/all`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

}
